import { useEffect, useRef, useState } from 'react';
import { businessConfig, navigationLinks } from '../../../config/businessConfig';

export default function Header({ onConsultation }) {
  const [menuOpen, setMenuOpen] = useState(false);
  const [scrolled, setScrolled] = useState(false);
  const menuButtonRef = useRef(null);
  const navigationRef = useRef(null);

  useEffect(() => {
    const handleScroll = () => setScrolled(window.scrollY > 24);
    handleScroll();
    window.addEventListener('scroll', handleScroll, { passive: true });
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);

  useEffect(() => {
    const handleKeyDown = (event) => {
      if (event.key === 'Escape') {
        setMenuOpen(false);
        menuButtonRef.current?.focus();
      }

      if (event.key === 'Tab' && menuOpen) {
        const focusable = [...navigationRef.current.querySelectorAll('a, button')];
        const first = focusable[0];
        const last = focusable.at(-1);
        if (event.shiftKey && document.activeElement === first) {
          event.preventDefault();
          last.focus();
        } else if (!event.shiftKey && document.activeElement === last) {
          event.preventDefault();
          first.focus();
        }
      }
    };
    document.body.classList.toggle('menu-open', menuOpen);
    window.addEventListener('keydown', handleKeyDown);
    if (menuOpen) navigationRef.current?.querySelector('a')?.focus({ preventScroll: true });
    return () => {
      document.body.classList.remove('menu-open');
      window.removeEventListener('keydown', handleKeyDown);
    };
  }, [menuOpen]);

  const closeMenu = () => setMenuOpen(false);

  return (
    <header className={`site-header ${scrolled ? 'site-header--scrolled' : ''} ${menuOpen ? 'site-header--menu-open' : ''}`}>
      <div className="container site-header__inner">
        <a className="brand" href="#inicio" aria-label={`${businessConfig.businessName}, ir al inicio`}>
          {businessConfig.assets.logo ? (
            <img src={businessConfig.assets.logo} alt={businessConfig.businessName} />
          ) : (
            <span className="brand__temporary" aria-label="Logo pendiente de incorporación">
              <span>{businessConfig.businessName}</span>
              <small>studio</small>
            </span>
          )}
        </a>

        <nav id="site-navigation" ref={navigationRef} className={`site-nav ${menuOpen ? 'site-nav--open' : ''}`} aria-label="Navegación principal">
          <ul>
            {navigationLinks.map((link) => (
              <li key={link.id}>
                <a href={`#${link.id}`} onClick={closeMenu}>{link.label}</a>
              </li>
            ))}
          </ul>
          <button className="button button--gold site-nav__cta" type="button" onClick={() => { closeMenu(); onConsultation(); }}>
            Consultar hora
          </button>
        </nav>

        <button
          ref={menuButtonRef}
          className={`menu-toggle ${menuOpen ? 'menu-toggle--open' : ''}`}
          type="button"
          aria-label={menuOpen ? 'Cerrar menú' : 'Abrir menú'}
          aria-expanded={menuOpen}
          aria-controls="site-navigation"
          onClick={() => setMenuOpen((current) => !current)}
        >
          <span /><span />
        </button>
      </div>
    </header>
  );
}
